import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import './../../pagescss/SubjectTopics.css';
import PdfFiles from "../AllData/PdfFiles";
import StudyOption from "../AllData/HomeData";
import TopNavbar from "../home/TopNavbar";
import TopHeader from "../home/TopHeader";
import UsePayments from "../AdminPanel/UsePayments";
import PaidItems from "../AllData/PaidItems";


function AllSubjectTopics({ subject, type }) {
  const allPdfs = PdfFiles;
  const [pdfs, setPdfs] = useState([]);
  const [bookmarkedPdfs, setBookmarkedPdfs] = useState([]);
  const [dounloadPdfs, setDounloadPdfs] = useState([]);
  const studyOptions = StudyOption;
  const matchingItem = studyOptions?.find(item => item.id === type);
  const iconName = matchingItem ? matchingItem.symbol : '📝';

  // Check payment
  const isPayment = localStorage.getItem('userPayment');

  const paidItems = PaidItems;
  const isPaid = paidItems.includes(type);

  const demoTopics = ["CP01", "CP02", "CP04", "CP06", "CP10", "CP15", "CC01", "CC02", "CC04", "CC06", "CC10", "CC15", "CB01", "CB02", "CB04", "CB06", "CB10", "CB15"];
  const isDemo = (topic) => {
    return demoTopics.includes(topic);
  }





  useEffect(() => {
    const fetchData = () => {
      try {
        const filteredPdfs = allPdfs.filter(pdf =>
          pdf.subject === subject && pdf.type === type
        );
        setPdfs(filteredPdfs);

        const storedBookmarks = localStorage.getItem('pdfBookmarks');
        if (storedBookmarks) {
          const bookmarksData = JSON.parse(storedBookmarks);
          // Removed userId filtering logic here
          setBookmarkedPdfs(bookmarksData);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [allPdfs, subject, type]);

  useEffect(() => {
    const storedDounloadPdfs = JSON.parse(localStorage.getItem('savePdfIdInLocalStorage')) || [];
    setDounloadPdfs(storedDounloadPdfs);
  }, []);

  const toggleBookmark = (pdf) => {
    const isBookmarked = bookmarkedPdfs.some(
      bookmark => bookmark.pdfId === pdf.id
    );

    const storedBookmarks = localStorage.getItem('pdfBookmarks');
    let allBookmarks = storedBookmarks ? JSON.parse(storedBookmarks) : [];

    if (isBookmarked) {
      // Remove bookmark based only on pdfId
      const updatedBookmarks = allBookmarks.filter(
        bookmark => bookmark.pdfId !== pdf.id
      );
      localStorage.setItem('pdfBookmarks', JSON.stringify(updatedBookmarks));
      setBookmarkedPdfs(updatedBookmarks);
    } else {
      // Add bookmark without userId
      const newBookmark = {
        pdfId: pdf.id,
        subject: pdf.subject,
        pdfData: pdf,
        timestamp: new Date().toISOString()
      };

      const updatedBookmarks = [...allBookmarks, newBookmark];
      localStorage.setItem('pdfBookmarks', JSON.stringify(updatedBookmarks));
      setBookmarkedPdfs(updatedBookmarks);
    }
  };



  return (
    <div className="subject-topics-page">
      <TopNavbar name={subject.charAt(0).toUpperCase() + subject.slice(1)} />
      <TopHeader name={subject.charAt(0).toUpperCase() + subject.slice(1)} />


      <div className="subject-categories">


        {pdfs.map((pdf) => {
          const isBookmarked = bookmarkedPdfs.some(
            bookmark => bookmark.pdfId === pdf.id
          );

          const isPdfDounloaded = dounloadPdfs.some(
            dounloadedpdf => dounloadedpdf === pdf.id
          );



          return (

            <>


              {isPayment || !isPaid || isDemo(pdf.topic) ? (<>

                <div className={`topic-card ${isBookmarked ? 'bookmarked' : ''}`} key={pdf.id}>
                  <div
                    className="bookmark-icon"
                    onClick={() => toggleBookmark(pdf)}
                    title={isBookmarked ? "Remove bookmark" : "Add bookmark"}
                  >
                    {isBookmarked ? '★' : '☆'}
                    {isBookmarked ? <p className="bookmarked-text">Marked</p> : <p className="bookmark-text">Mark</p>}
                  </div>

                  {type !== "syllabus" ? (
                    <>

                      {/*    <Link to={`/onlinereadbook/${type}/${subject}/${pdf.topic}`} className="link">
                        <p> {iconName} {pdf.name} </p>
                      </Link>     */}

                      {isPdfDounloaded ? (
                        <Link
                          // to={`/pdfs/${pdf.pdfPath}`} 
                          to={`/pdfviewer/${pdf.id}`}
                          className="link"  >
                          <p> {iconName} {pdf.name}</p>
                          <p style={{ fontSize: "8px", color: "green" }}>Dounloaded</p>
                        </Link>
                      ) : (
                        <Link to={`/pdfviewer/${pdf.id}`} className="link">
                          <p> {iconName} {pdf.name} </p>
                        </Link>
                      )}

                    </>
                  ) : (
                    <>
                      {isPdfDounloaded ? (
                        <Link
                          // to={`/pdfs/${pdf.pdfPath}`} 
                          to={`/pdfviewer/${pdf.id}}`}
                          className="link"  >
                          <p> {iconName} {pdf.name}</p>
                          <p style={{ fontSize: "8px", color: "green" }}>Dounloaded</p>
                        </Link>
                      ) : (
                        <Link to={`/pdfviewer/${pdf.id}`} className="link">
                          <p> {iconName} {pdf.name} </p>
                        </Link>
                      )}
                    </>
                  )}

                </div>

              </>) : (<>

                <div className={`topic-card ${isBookmarked ? 'bookmarked' : ''}`} key={pdf.id}>
                  <div
                    className="bookmark-icon"
                    // onClick={() => toggleBookmark(pdf)}
                    title={isBookmarked ? "Remove bookmark" : "Add bookmark"}
                  >

                    🔒
                    {/*   {isBookmarked ? '★' : '☆'} 
                    {isBookmarked ? <p className="bookmarked-text">Marked</p> : <p className="bookmark-text">Mark</p>} */}
                  </div>

                  {type !== "syllabus" ? (
                    <>

                      <Link to={`/premium-paywall`} className="link">
                        <p> {iconName} {pdf.name} </p>
                      </Link>

                    </>
                  ) : (
                    <>
                      {isPdfDounloaded ? (
                        <Link to="/premium-paywall" className="link" rel="noopener noreferrer" >
                          <p> {iconName} {pdf.name} </p>
                          <p style={{ fontSize: "8px", color: "green" }}>Dounloaded</p>
                        </Link>
                      ) : (
                        <Link to={`/premium-paywall`} className="link">
                          <p> {iconName} {pdf.name} </p>
                        </Link>
                      )}
                    </>
                  )}

                </div>

              </>)}


            </>



          );
        })}
      </div>
    </div >
  );
}

export default AllSubjectTopics;